// Registration table to route messages to correct store handlers
export const ROUTE_HANDLER = {
  "export": "bulkExport"
}